import { CDElement } from "./CDElement";
import { CDSelector } from "./CDSelector";

export class CDRoot extends CDElement
{
  constructor() 
  {
    super( CDElement.CDRootType );
  }

  get firstSelector():CDSelector
  {
    let children = this.children;

    for ( let child of children ) 
    {
      if ( child.isSelector ) 
      {
        return child as CDSelector;
      }
    }

    return null;
  }
}